import FormData from 'form-data'
import { apiAxios } from '@/helpers'
import queueToast from '@/helpers/queueToast'

export const uploadFile = async (commit, photo) => {
  let file = new FormData()
  file.append('file', photo)

  const result = await apiAxios.post('/upload/file', file, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  let filename = result.data.data.file.filename
  queueToast(result.data.data.message.reason)
  commit('updateFile', filename)
}
